module.exports = __webpack_public_path__ + "img/timesheet-log-book_B09NKL36VC.385654f7.jpg";